import type { ValidationValueMessage } from "react-hook-form";

export const validationOfRequired: ValidationValueMessage<boolean> = {
  value: true,
  message: "入力必須",
};
